import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Paper, Box, Typography, TextField, FormControlLabel,
} from '@material-ui/core';
import validator, { VALIDATOR_CONST } from '../../../../common/validator';
import { ERROR } from '../../../../common/message';
import { getMessage } from '../../../../common/util';
import '../TargetSearchComponent';
import { TARGET_SEARCH_DISP_ITEM } from '../../../../common/const';
import {
  setOfficeCountFrom,
  setOfficeCountTo,
  setDispOfficeCountFrom,
  setDispOfficeCountTo,
  setCheckOfficeCountFrom,
  setCheckOfficeCountTo,
  setErrMsgOfficeCount,
  setDispJgkbList,
  setJgkbList,

} from '../../../actions/TargetAction';
import styles from '../style.module.css';
import CustomCheckbox from '../../common/CustomCheckbox';

class JigyosyoInfomationParts extends Component {
  /**
  *事業所数FROM文字種、最大桁数のチェック
  *事業所数TO文字種、最大桁数のチェック
  */
  onBlurOfficeCount = () => {
    const {
      dispOfficeCountFrom,
      dispOfficeCountTo,
      setOfficeCountFromAct,
      setOfficeCountToAct,
      setCheckOfficeCountFromAct,
      setCheckOfficeCountToAct,
      setErrMsgOfficeCountAct,
      setDispOfficeCountFromAct,
      setDispOfficeCountToAct,
    } = this.props;

    // カンマ除去
    const officeCountFrom = dispOfficeCountFrom && dispOfficeCountFrom.replace(/,/g, '');
    const officeCountTo = dispOfficeCountTo && dispOfficeCountTo.replace(/,/g, '');

    // リクエストパラメータ用項目設定
    setOfficeCountFromAct(officeCountFrom);
    setOfficeCountToAct(officeCountTo);

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(officeCountFrom, VALIDATOR_CONST.PATERN_POSITIVE, msgs1);
    validator.checkChar(officeCountTo, VALIDATOR_CONST.PATERN_POSITIVE, msgs2);
    validator.checkNumberRange(officeCountFrom, 1, 99999, msgs1);
    validator.checkNumberRange(officeCountTo, 1, 99999, msgs2);
    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgOfficeCountAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckOfficeCountFromAct(errFlg1);
      setCheckOfficeCountToAct(errFlg2);
      return;
    }
    setErrMsgOfficeCountAct();
    setCheckOfficeCountFromAct(false);
    setCheckOfficeCountToAct(false);

    // 表示内容を更新(3桁カンマを付与)
    setDispOfficeCountFromAct(officeCountFrom ? Number(officeCountFrom).toLocaleString() : '');
    setDispOfficeCountToAct(officeCountTo ? Number(officeCountTo).toLocaleString() : '');
  }

  /**
   *事業所区分チェックボックス変更
   */
  onChangeJgkbCheckBox = (str) => {
    const { setJgkbListAct, jgkbList } = this.props;

    // 選択した事業所区分を取得
    const selItem = str;
    // 事業所区分リスト編集用の変数を宣言
    let newJgkbList = [];

    if (jgkbList.indexOf(str) === -1) {
      // 選択した市場区分を事業所区分リストに追加
      newJgkbList.push(selItem);
      // 他に選択済の事業所区分がある場合は事業所区分リストに追加
      if (jgkbList && jgkbList.length > 0) {
        newJgkbList = jgkbList.concat(newJgkbList);
      }
    } else {
      // チェックOFFに変更した事業所区分の配列位置を取得
      const delIndex = jgkbList.indexOf(selItem);
      // 配列位置が取得できた場合、該当の事業所区分を削除
      if (delIndex >= 0) {
        newJgkbList = jgkbList.concat(newJgkbList);
        newJgkbList.splice(delIndex, 1);
      }
    }
    setJgkbListAct(newJgkbList);
  };

  render() {
    const {
      dispOfficeCountFrom,
      dispOfficeCountTo,
      checkErrFlg,
      errMsgOfficeCount,
      setDispOfficeCountFromAct,
      setDispOfficeCountToAct,
      dispJgkbList,
      jgkbList,
      targetingDispItems,
    } = this.props;

    // 事業所区分の表示・非表示設定
    let dispFlg = false;
    if (targetingDispItems) {
      targetingDispItems.search_option_list.forEach((label) => {
        if (label.item_name === TARGET_SEARCH_DISP_ITEM.JIGYOSYOKBN) {
          dispFlg = true;
        }
      });
    }

    return (
      <Box className={`${styles.parts}`}>
        <Paper elevation={0} className={`${styles.sectionBox}`}>
          <Box className={`${styles.alignItemsCenter} ${styles.displayFlex} ${styles.marginBottomTitle}`}>
            <Box className={`${styles.sectionTitleIcon} ${styles.marginRightHalf}`} />
            <Typography variant="h6" component="div" className={`${styles.sectionTitle}`}>事業所情報</Typography>
          </Box>
          <Box className={`${styles.marginBottom2}`}>
            <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>事業所数</Typography>
            <Box className={`${styles.displayFlex} ${styles.alignItemsFlexEnd}`}>
              <TextField
                variant="outlined"
                margin="normal"
                value={dispOfficeCountFrom || ''}
                onChange={(ev) => setDispOfficeCountFromAct(ev.target.value)}
                onBlur={this.onBlurOfficeCount}
                error={checkErrFlg.checkOfficeCountFrom}
                InputProps={{ classes: { input: styles.inputSizing } }}
                placeholder="0000"
              />
              <Box className={`${styles.displayFlex} ${styles.flexDirectionColumn} ${styles.marginRight1} ${styles.marginLeft1} ${styles.marginBottom15}`}>
                <Typography variant="body2">～</Typography>
              </Box>
              <TextField
                variant="outlined"
                margin="normal"
                value={dispOfficeCountTo || ''}
                onChange={(ev) => setDispOfficeCountToAct(ev.target.value)}
                onBlur={this.onBlurOfficeCount}
                error={checkErrFlg.checkOfficeCountTo}
                InputProps={{ classes: { input: styles.inputSizing } }}
                placeholder="0000"
              />
              <Box className={`${styles.errorMsgAreaMargin}`}>
                <Typography variant="body2" className={`${styles.errorMsg}`} component="span">{errMsgOfficeCount}</Typography>
              </Box>
            </Box>
          </Box>
          {dispFlg && (
            <Box className={`${styles.marginBottom1}`}>
              <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>事業所区分</Typography>
              <Box className={`${styles.jgkbCheckboxBlock}`}>
                {dispJgkbList && dispJgkbList.map((item, i) => (
                  <Box key={i} className={`${styles.jgkbCheckbox} ${styles.marginLeftHalf}`}>
                    <FormControlLabel
                      control={(
                        <CustomCheckbox
                          key={i}
                          checked={jgkbList && jgkbList.indexOf(item.cdshbtch) >= 0}
                          onChange={() => this.onChangeJgkbCheckBox(item.cdshbtch)}
                        />
                      )}
                      label={item.cdch_im}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          )}
        </Paper>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    officeCountFrom: state.target.officeCountFrom,
    officeCountTo: state.target.officeCountTo,
    dispOfficeCountFrom: state.target.dispOfficeCountFrom,
    dispOfficeCountTo: state.target.dispOfficeCountTo,
    checkErrFlg: state.target.checkErrFlg,
    errMsgOfficeCount: state.target.errMsgOfficeCount,
    dispJgkbList: state.target.dispJgkbList,
    jgkbList: state.target.jgkbList,
    targetingDispItems: state.target.targetingDispItems,
  }),
  (dispatch) => ({
    setOfficeCountFromAct: (str) => dispatch(setOfficeCountFrom(str)),
    setOfficeCountToAct: (str) => dispatch(setOfficeCountTo(str)),
    setDispOfficeCountFromAct: (str) => dispatch(setDispOfficeCountFrom(str)),
    setDispOfficeCountToAct: (str) => dispatch(setDispOfficeCountTo(str)),
    setCheckOfficeCountFromAct: (bool) => dispatch(setCheckOfficeCountFrom(bool)),
    setCheckOfficeCountToAct: (bool) => dispatch(setCheckOfficeCountTo(bool)),
    setErrMsgOfficeCountAct: (sr) => dispatch(setErrMsgOfficeCount(sr)),
    setDispJgkbListAct: (obj) => dispatch(setDispJgkbList(obj)),
    setJgkbListAct: (obj) => dispatch(setJgkbList(obj)),
  }),
)(JigyosyoInfomationParts);
